import {
  Box,
  Flex,
  Stack,
  Container,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
  useToast,
  Link,
} from "@chakra-ui/react";
import React, { useState } from "react";
import {
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdFacebook,
  MdOutlineEmail,MdRocketLaunch
} from "react-icons/md";


import { BsGithub, BsDiscord, BsPerson,BsLinkedin } from "react-icons/bs";
import { Player } from "@lottiefiles/react-lottie-player";
import emailjs from '@emailjs/browser';

function Contact(props) {

    const [conEmail,setConEmail]=useState('')
    const [conName,setConName]=useState('')
    const [conMessage,setConMessage]=useState('')
    const toast = useToast()

    const templateParams={
        'from_name':conName,
        'message':conMessage,
        'email':conEmail,
       
    }

    const sendEmail=()=>{
        if(conName===''){
            toast({
                title: `Please Enter Name`,
                position: 'top-right',
                variant: 'top-accent',
                isClosable: true,
              })
              return
        }
        if(conEmail===''){
            toast({
                title: `Please Enter Email`,
                position: 'top-right',
                variant: 'top-accent',
                isClosable: true,
              })
              return
        }
        if(conMessage===''){
            toast({
                title: `Please Enter Message`,
                position: 'top-right',
                variant: 'top-accent',
                isClosable: true,
              })
              return
        }
        emailjs.send('service_crs4nvl','template_uz0yhs7', templateParams, 'EHhnjsS-kwFQ2YBWF')
        .then((response) => {
           console.log('SUCCESS!', response.status, response.text);
           toast({
            title: `Message Sent Successfully`,
            status: 'success',
            isClosable: true,
          })
        }, (err) => {
           console.log('FAILED...', err);
           toast({
            title: `Something went wrong Please resend`,
            status: 'error',
            isClosable: true,
          })
        });
    }
  return (
    <Container
    id="contactme"
      border={"solid #ffd3366b"}
      w={{ base: "95%", md: "80%" }}
      borderRadius="40px"
      bg="csdark"
      padding={3}
      maxW="full"
      mt={0}
      centerContent
      overflow="hidden"
    >
      <Flex>
        <Box
          bg="csudark"
          color="cpnormal"
          borderRadius="40px"
          m={{ sm: 4, md: 16, lg: 10 }}
          p={{ sm: 5, md: 5, lg: 16 }}
        >
          <Box p={4}>
            <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
              <WrapItem>
                <Box>
                  <Heading>Contact</Heading>
                  <Text mt={{ sm: 3, md: 3, lg: 5 }} color="gray.500">
                    Fill up the form below to contact
                  </Text>
                  <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                    <VStack
                      textAlign={"left"}
                      pl={0}
                      spacing={3}
                      alignItems="flex-start"
                    >
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        color="#DCE2FF"
                        textAlign={"left"}
                        _hover={{ border: "2px solid #ffc636" }}
                        leftIcon={<MdPhone color="#EDAC33" size="20px" />}
                      >
                        +91-8606728194
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        color="#DCE2FF"
                        _hover={{ border: "2px solid #ffc636" }}
                        leftIcon={<MdEmail color="#EDAC33" size="20px" />}
                      >
                        contact.canopus@gmail.com
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        color="#DCE2FF"
                        _hover={{ border: "2px solid #ffc636" }}
                        leftIcon={<MdLocationOn color="#EDAC33" size="20px" />}
                      >
                        Malappuram,India
                      </Button>
                    </VStack>
                  </Box>
                  <HStack
                    mt={{ lg: 10, md: 10 }}
                    spacing={5}
                    px={5}
                    alignItems="flex-start"
                  >
                    <Link href="https://suhail-k.github.io/"
                    isExternal
                    >
                    <IconButton
                      aria-label="facebook"
                      variant="ghost"
                      size="lg"
                      isRound={true}
                      _hover={{ bg: "#2f4474" }}
                      icon={<MdRocketLaunch size="28px" />}
                    /></Link>
                    <Link
                    isExternal
                    href="https://github.com/SUHAIL-K"
                    >
                    <IconButton
                      aria-label="github"
                      variant="ghost"
                      size="lg"
                      isRound={true}
                      _hover={{ bg: "#2f4474" }}
                      icon={<BsGithub size="28px" />}
                    />
                    </Link>
                    <Link
                    isExternal
                    href="https://www.linkedin.com/in/suhail-k/"
                    >
                    <IconButton
                      aria-label="discord"
                      variant="ghost"
                      size="lg"
                      isRound={true}
                      _hover={{ bg: "#2f4474" }}
                      icon={<BsLinkedin size="28px" />}
                    />
                    </Link>
                  </HStack>
                </Box>
              </WrapItem>
              <WrapItem>
                <Box bg="white" borderRadius="lg">
                  <Box m={8} color="#0B0E3F">
                   <form onSubmit={()=>{
                    console.log("hiii");
                   }} >
                   <VStack spacing={5}>
                      <FormControl id="name">
                        <FormLabel>Your Name</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<BsPerson color="gray.800" />}
                          />
                          <Input onChange={(e)=>{
                            setConName(e.target.value)
                          }} type="text" size="md" />
                        </InputGroup>
                      </FormControl>
                      <FormControl id="name">
                        <FormLabel>Mail</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<MdOutlineEmail color="gray.800" />}
                          />
                          <Input onChange={(e)=>{
                            setConEmail(e.target.value)
                          }} type="text" size="md" />
                        </InputGroup>
                      </FormControl>
                      <FormControl id="name">
                        <FormLabel>Message</FormLabel>
                        <Textarea
                        onChange={(e)=>{
                            setConMessage(e.target.value)
                          }}
                          borderColor="gray.300"
                          _hover={{
                            borderRadius: "gray.300",
                          }}
                          placeholder="message"
                        />
                      </FormControl>
                      <FormControl id="name" float="right">
                        <Button
                        onClick={sendEmail}
                          variant="solid"
                          bg="#0D74FF"
                          color="white"
                          _hover={{}}
                        >
                          Send Message
                        </Button>
                      </FormControl>
                    </VStack>
                   </form>
                  </Box>
                </Box>
              </WrapItem>
            </Wrap>
          </Box>
        </Box>
      </Flex>
    </Container>
  );
}

export default Contact;
